import { DELETE_INTERVENTION_SUCCESS } from 'modules/interventions/actionTypes';
import type { DeleteInterventionSuccessAction } from 'modules/interventions/types/actions';
import * as types from 'modules/leads/actionTypes';
import type { DeleteLeadSuccessAction, FetchLeadsSuccessAction, LeadSuccessAction, StoredLead } from 'modules/leads/types';
import { formatLead } from 'modules/leads/utils';
import { createEntityAdapter, createReducer, type EntitySlice } from 'utils/ReduxUtils';

type LeadsData = EntitySlice<StoredLead>;

const leadAdapter = createEntityAdapter<StoredLead>({ selectId: ({ id }) => id });

const upsertMany = (state: LeadsData, { payload }: FetchLeadsSuccessAction): LeadsData =>
  leadAdapter.updateMany(state, payload.content.map(formatLead));

const upsertOne = (state: LeadsData, { payload }: LeadSuccessAction): LeadsData =>
  leadAdapter.updateOne(state, formatLead(payload.lead));

const removeOne = (state: LeadsData, { payload: leadId }: DeleteLeadSuccessAction): LeadsData =>
  leadAdapter.removeOne(state, leadId);

const detachDirectMessage = (state: LeadsData, { payload: { interventionId } }: DeleteInterventionSuccessAction): LeadsData =>
  leadAdapter.updateMany(
    state,
    state.ids.reduce<Array<Pick<StoredLead, 'id' | 'directMessageId'>>>((changes, id) => {
      if (state.entities[id].directMessageId === interventionId) {
        changes.push({ id, directMessageId: undefined });
      }
      return changes;
    }, [])
  );

export default createReducer<LeadsData>(leadAdapter.getInitialState(), {
  [types.FETCH_SUCCESS]: upsertMany,
  [types.ASSIGN_SUCCESS]: upsertOne,
  [types.SET_STATUS_SUCCESS]: upsertOne,
  [types.DELETE_LEAD_SUCCESS]: removeOne,
  [DELETE_INTERVENTION_SUCCESS]: detachDirectMessage,
});
